import { apiSlice } from '../apiSlice';
import { Region } from '../../types/Region';

const endpointUrl = '/regions';

export const initialState: Region = {
  id: '',
  description: '',
  enabled: true
};

function getRegions() {
  return `${endpointUrl}`;
}

function getRegion({ id }: { id: string }) {
  return `${endpointUrl}/${id}`;
}

function createRegion({
  description
}: {
  description: string;
}) {
  return {
    url: `${endpointUrl}`,
    method: 'POST',
    body: {
      description
    }
  };
}

function updateRegion({
  id,
  description
}: {
  id: string;
  description: string;
}) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'PUT',
    body: { description }
  };
}

function toggleRegionEnabled({
  id,
  enabled
}: {
  id: string;
  enabled: boolean;
}) {
  return {
    url: `${endpointUrl}/${id}/enabled`,
    method: 'PATCH',
    body: { enabled }
  };
}

function deleteRegion({ id }: { id: string }) {
  return {
    url: `${endpointUrl}/${id}`,
    method: 'DELETE'
  };
}

export const regionApiSlice = apiSlice.injectEndpoints({
  endpoints: ({ query, mutation }) => ({
    getAllRegions: query<Region[], void>({
      query: getRegions,
      providesTags: ['Regions']
    }),
    getRegion: query<Region, { id: string }>({
      query: getRegion,
      providesTags: ['Regions']
    }),
    createRegion: mutation<
      void,
      {
        description: string;
      }
    >({
      query: createRegion,
      invalidatesTags: ['Regions']
    }),
    updateRegion: mutation<
      void,
      { id: string; description: string }
    >({
      query: updateRegion,
      invalidatesTags: ['Regions']
    }),
    toggleRegionEnabled: mutation<
      void,
      { id: string; enabled: boolean }
    >({
      query: toggleRegionEnabled,
      invalidatesTags: ['Regions']
    }),
    deleteRegion: mutation<void, { id: string }>({
      query: deleteRegion,
      invalidatesTags: ['Regions']
    })
  })
});

export const {
  useGetAllRegionsQuery,
  useGetRegionQuery,
  useCreateRegionMutation,
  useUpdateRegionMutation,
  useToggleRegionEnabledMutation,
  useDeleteRegionMutation
} = regionApiSlice;

export default regionApiSlice;
